/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module IcapProfileModule
 */

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { IIcapNsxDefenderConfig } from 'generated-types';

/**
 * @description
 *
 *   IcapNsxDefenderConfig config item.
 *
 * @author Satish Pednekar
 */
export class IcapNsxDefenderConfigConfigItem extends MessageItem<IIcapNsxDefenderConfig> {
    /**
     * @constructor
     */
    constructor(args = {}) {
        const extendedArgs = {
            objectType: 'IcapNsxDefenderConfig',
            ...args,
        };

        super(extendedArgs);
    }
}
